<template>
  <div class="container">
    <div class="topImg" ref="topImg">
      <a href="/" target="_blank" v-if="viewImgTop">
        <img :src="content.fileName" style="width: 100%" />
      </a>
    </div>
    <div class="containerWrap" :style="containerStyle">
      <div class="containerTop">
        <div class="wrap clearfloat">
          <div class="fl containerTopL">
            <router-link to="/">
              <img src="../assets/img/logo.png" alt="">
            </router-link>
          </div>
          <div class="fr containerTopR">
            <a href="" target="_blank">旧版入口</a>
            <a href="http://www.gsjtw.cc/" target="_blank">甘肃建投</a>
            <!-- <a href="http://www.gsjtky.com/WebSite" target="_blank">建投站群</a> -->
            <a href="/organization" target="_blank">建投站群</a>
          </div>
          <div class="topLogoMainRight">
            <div class="header_search">
              <div>
                <el-input v-model="searchValue" placeholder="请输入关键词" style="width: 300px;"></el-input>
                <el-button
                  type="submit"
                  class="btn "
                  style="background-color: rgba(255,255,255,0.5); border-radius:0px; color: #000; border-left: 1px solid #333;"
                  @click="handleSearch"
                  >搜索</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="header">
        <div class="wrap clearfloat">
          <div class="nav_box">
            <ul class="clearfloat">
              <li :class="{'active':active == 0}">
                <div class="nav_grop">
                  <h2><router-link to="/">网站首页</router-link></h2>
                </div>
              </li>
              <li v-for="(item, index) in navList" :key="index" :class="{'active':active == item.id}">
                <div
                  class="nav_grop" 
                  @mouseenter="navShow(item.channelId)"
                  @mouseleave="navClose()">
                  <h2>
                    <a 
                      v-if="item.child.length && item.child[0].url && item.child[0].url !== ''" 
                      target="_blank"
                      :href="item.url">
                      {{item.name}}
                    </a>
                    <a 
                      v-if="item.child.length" 
                      :href="item.catalog == 1 ? `/listPage/${item.child[0].entTChannelUuid}` : item.catalog == 2 ? `/list/${item.child[0].entTChannelUuid}` : `/listPic/${item.child[0].entTChannelUuid}`">
                      {{item.name}}
                    </a>
                    <a 
                      v-if="!item.child.length" 
                      :href="item.catalog == 1 ? `/listPage/${item.entTChannelUuid}` : item.catalog == 2 ? `/list/${item.entTChannelUuid}` : `/listPic/${item.entTChannelUuid}`">
                      {{item.name}}
                    </a>
                  </h2>
                  <el-collapse-transition>
                    <div class="nav_down" v-show="navDown == item.channelId">
                      <div class="nav_down_wrap clearfloat" v-show="item.child.length != 0">
                        <p v-for="(item1, index1) in item.child" :key="index1">
                          <!-- <a 
                            v-if="item1.url && item1.url !== ''" 
                            target="_blank" 
                            :href="item1.url">
                            {{item1.name}}
                          </a> -->
                          <a 
                            :href="item1.catalog === 1 ? `/listPage/${item1.entTChannelUuid}` : item1.catalog === 2 ? `/list/${item1.entTChannelUuid}` : `/listPic/${item1.entTChannelUuid}`">
                            {{item1.name}}
                          </a>
                        </p>
                      </div>
                    </div>
                  </el-collapse-transition>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="main">
        <router-view></router-view>
      </div>
      <div class="footer">
        <div class="footerWrap">
          <div class="wrap">
            <el-row :gutter="30">
              <el-col :span="8">
                <div class="footerLeft">
                  <div class="footerLeftInner">
                    <div class="pic">
                      <img src="../assets/img/wx.jpg" alt="">
                    </div>
                    <div class="txt">
                      甘肃建投绿色建材产业发展集团有限公司
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="14">
                <div class="footerRight">
                  <div class="footerRightInner">
                    <span>版权所有</span>     
                    <span>甘肃建投绿色建材产业发展集团有限公司</span>
                    <span><a href="http://beian.miit.gov.cn" target="_blank">陇ICP备16000460号-1</a></span>
                    <span>邮编：730000</span>
                  </div>
                  <div class="footerRightInner">
                    <span>地址：兰州市安宁区宝石花路27号安澜祥园5号楼</span>
                    <span> <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=62010502000426" target="_blank"><img src="../assets/img/ba.png" alt=""> 甘公网安备 62010502000426号</a></span>
                  </div>
                  <div class="footerRightInner">
                    <span>电话：0931-2884043</span>
                    <span>传真：0931-2884043</span>
                    <span>E-mail：gsjtjc@163.com</span>
                  </div>
                  <div class="footerRightInner" v-html="txtImg">
                    <!-- <script type="text/javascript">document.write(unescape("%3Cspan id='cnzz_stat_icon_1259563611'%3E%3C/span%3E%3Cscript src='https://s4.cnzz.com/stat.php%3Fid%3D1259563611%26show%3Dpic' type='text/javascript'%3E%3C/script%3E"));</script> -->
                  </div>
                  <div class="footerRightInner bt">
                    <span>本站样式已版权保护</span>
                    <span>不得镜像与仿制</span>
                    <span>违者必究</span>
                    <span>Copyright ©2019</span>
                    <span><a href="www.gsjtky.com" target="_blank">www.gsjtky.com</a></span>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getNavChannel ,getAdvert} from '@/api/common'

export default {
  name: '',
  data(){
    return {
      content: '',
      viewImgTop: true,
      containerStyle: {},
      txtImg: '',
      searchValue: '',
      active: 0,
      navList: [],
      navListN: [
        {
            "id":1,
            "name":"企业概况",
            "isIndex":0,
            "url": '',
            "group_list":[
                {
                    "id":1,
                    "name":"企业简介",
                    "url": '',
                    "nav_id":2,
                    "have_list":1,
                    "create_time":"2020-12-22T07:10:13.037Z"
                },
                {
                    "id":2,
                    "name":"领导班子",
                    "url": '',
                    "nav_id":2,
                    "have_list":1,
                    "create_time":"2020-12-22T07:10:13.037Z"
                }
            ]
        },
        {
            "id":2,
            "name":"新闻动态",
            "isIndex":0,
            "url": '',
            "group_list":[
                {
                    "id":7,
                    "name":"公司动态",
                    "url": '',
                    "nav_id":3,
                    "have_list":0,
                    "create_time":"2020-12-22T07:11:14.391Z"
                },
                {
                    "id":8,
                    "name":"行业要闻",
                    "url": '',
                    "nav_id":3,
                    "have_list":0,
                    "create_time":"2020-12-22T07:11:41.023Z"
                },
                {
                    "id":9,
                    "name":"建投新闻",
                    "url": '',
                    "nav_id":3,
                    "have_list":0,
                    "create_time":"2020-12-22T07:11:41.023Z"
                },
                {
                    "id":9,
                    "name":"公示公告",
                    "url": '',
                    "nav_id":3,
                    "have_list":0,
                    "create_time":"2020-12-22T07:11:41.023Z"
                },
                {
                    "id":9,
                    "name":"外媒关注",
                    "url": '',
                    "nav_id":3,
                    "have_list":0,
                    "create_time":"2020-12-22T07:11:41.023Z"
                },
                {
                    "id":9,
                    "name":"基层声音",
                    "url": '',
                    "nav_id":3,
                    "have_list":0,
                    "create_time":"2020-12-22T07:11:41.023Z"
                }
            ]
        },
        {
            "id":3,
            "name":"党建工作",
            "isIndex":0,
            "url": '',
            "group_list":[]
        },
        {
            "id":4,
            "name":"科技创新",
            "isIndex":0,
            "url": '',
            "group_list":[
                {
                    "id":14,
                    "name":"科技成果",
                    "url": '',
                    "nav_id":4,
                    "have_list":0,
                    "create_time":"2020-12-22T07:12:55.466Z"
                },
                {
                    "id":15,
                    "name":"产品展示",
                    "url": '',
                    "nav_id":4,
                    "have_list":0,
                    "create_time":"2020-12-22T07:13:02.484Z"
                }
            ]
        },
        {
            "id":6,
            "name":"文化建设",
            "isIndex":0,
            "url": '',
            "group_list":[
                {
                    "id":14,
                    "name":"职工文苑",
                    "url": '',
                    "nav_id":4,
                    "have_list":0,
                    "create_time":"2020-12-22T07:12:55.466Z"
                },
                {
                    "id":14,
                    "name":"企业文化",
                    "url": '',
                    "nav_id":4,
                    "have_list":0,
                    "create_time":"2020-12-22T07:12:55.466Z"
                },
            ]
        },
        {
            "id":5,
            "name":"人才招聘",
            "isIndex":0,
            "url": '',
            "group_list":[]
        },
      ],
      navDown: 0,

    }
  },
  mounted(){
    this.getPath()
    this.footerImg()
    this.getNavChannel()
    let url = this.$route.name
    if (url == 'home') {
      this.srollimg()
    }
  },
  created(){

  },
  watch:{
    '$route':'getPath'
  },
  methods: {
    srollimg() {
      var _this = this
      let data = {
        applicationUuid: _this.webId,
        advertType: 4
      }
      getAdvert(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          if (data.length) {
            _this.content = data[0]
            this.$nextTick(() => {
              this.srollTop()
            })
          }
        }
      })
    },

    srollTop() {
      var _this = this
      var heightT
      this.$refs.topImg && setTimeout(() => {
        heightT = this.$refs.topImg.offsetHeight
        _this.containerStyle = {
          marginTop: heightT + 'px'
        }
      }, 600)
      setTimeout(() => {
        _this.containerStyle = {
          marginTop: 0
        }
      }, 3000)
      setTimeout(() => {
        _this.viewImgTop = false
      }, 5000)
    },
    // 获取导航
    getNavChannel() {
      var _this = this
      let data = {
        applicationUuid: _this.webId
      }
      getNavChannel(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.navList = data.slice(0, 6)
          // data.length &&
          //   data.forEach((line, index) => {
          //     if (line.child.length) {
          //       line.url = _this.navList[index].index + '/' + line.child[0].entTChannelUuid
          //     } else {
          //       line.url = _this.navList[index].index + '/' + line.entTChannelUuid
          //     }
          //   })
          // _this.navSubList = [
          //   {
          //     id: 1,
          //     name: '网站首页',
          //     url: '/'
          //   },
          //   ...data
          // ]
        }
      })
    },
    handleSearch() {
      var _this = this
      if (!_this.searchValue || _this.searchValue == '') {
        this.$message({
          message: '请输入关键词',
          type: 'warning'
        })
      } else {
        window.location.href = `/search/${_this.searchValue}`
        // window.open(`/search/${_this.searchValue}`)
      }
    },
    // 二级导航展开
    navShow(d){
      let _this = this
      // _this[d] = true
      _this.navDown = d
    },
    // 二级导航收起
    navClose(){
      let _this = this
      // _this[d] = false
      _this.navDown = 0
    },
    haddleNav(index, params){
      var _this = this

      _this.active = index
      _this.$router.push(params.url)
    },
    getPath(){
      var _this = this

      _this.active = _this.$route.meta.index
    },
    footerImg() {
      var _this = this

      _this.txtImg = unescape("%3Cspan id='cnzz_stat_icon_1259563611'%3E%3C/span%3E%3Cscript src='https://s4.cnzz.com/stat.php%3Fid%3D1259563611%26show%3Dpic' type='text/javascript'%3E%3C/script%3E")
      // console.log('txtImg :>> ', _this.txtImg);
    }
  }
}
</script>
<style>
.topImg {
    position: fixed;
    width: 100%;
    height: auto;
    top: 0;
    left: 0;
    z-index: -10;
    overflow: hidden;
    -moz-transition: all 1.5s ease-out;
    -webkit-transition: all 1.5s ease-out;
    -o-transition: all 1.5s ease-out;
    transition: all 1.5s ease-out;
}

.topImg img {
    display: block;
    width: 100%;
    /* height: 100%; */
}
.containerWrap {
    -moz-transition: all 1.5s ease-out;
    -webkit-transition: all 1.5s ease-out;
    -o-transition: all 1.5s ease-out;
    transition: all 1.5s ease-out;
    z-index: 10;
    background-color: #fff;
}
.containerTop {
  height: 500px;
  background-image: url(../assets/img/header_bg.jpg);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.containerTop .wrap {
  height: 100%;
  position: relative;
}
.containerTopL {
  margin-top: 48px;
}
.containerTopR a {
  display: inline-block;
  height: 34px;
  line-height: 34px;
  text-align: center;
  margin-left: 6px;
  padding: 0 12px;
  color: #fff;
  font-size: 16px;
  background-color: #0162B3;
  margin-top: 55px;
}
.header {
  text-align: center;
  background-color: #0162B1;
  /* background-image: url(../assets/img/header_bg.png); */
  /* background-size: 100% auto;
  background-position: center;
  background-repeat: no-repeat;
  background-color: rgba(13,30,46,.8); */
  /* position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 22; */
}
.headerLogo {
  margin-top: 6px;
  /* margin-bottom: 20px; */
}
.headerLogo img {
  /* width: 360px; */
  height: 46px;
  width: auto;
  vertical-align: middle;
}
.headerNavTxt {
  display: inline-block;
  min-width: 45px;
  color: #fff;
  font-size: 20px;
  letter-spacing: 4px;
  cursor: pointer;
}
.headerNavTxt:hover {
  color: #BC8F68;
}
.main {
  min-height: 500px;
}
.footer {
  background: #0162B1;
  color: #fff;
}
.footerWrap {
  padding: 16px 0 10px;
  text-align: left;
}
.footerLeft {
  text-align: right;
}
.footerLeftInner {
  display: inline-block;
}
.footerLeft .pic {
  text-align: center;
}
.footerLeft img {
  width: 130px;
  height: auto;
}
.footerLeft .txt {
  height: 30px;
  line-height: 30px;
  color: #80b2db;
  font-size: 13px;
}
.footerRightInner {
  font-size: 14px;
  line-height: 32px;
}
.footerRightInner span {
  display: inline-block;
  margin-right: 30px;
}
.footerRightInner a {
  color: #fff;
}
.footerRightInner.bt,
.footerRightInner.bt a {
  color: #80b2db;
}

.nav_box {
  /* height: 38px; */
  /* background-color: #1970b9; */
  line-height: 64px;
}
.nav_box ul li {
  height: 64px;
  line-height: 64px;
  float: left; 
  width: 14.28%; 
  color: #fff;
  text-align: center;
  position: relative;
}
/* .nav_box ul li a {
  display: block;
} */
.nav_grop {
  /* width: 82px; */
  height: 100%;
  /* margin: 5px auto 0; */
  position: relative;
}
.nav_box ul li h2 {
  text-align: center;
  height: 100%;
  font-size: 20px;
  overflow: hidden;
}
.nav_box ul li h2 a {
  display: block;
  color: #fff;
}
.nav_grop:hover h2 {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.nav_grop:hover h2 a {
  background-color: #074378;
}
.nav_box ul li.active h2 a {
  background-color: #074378;
}
.nav_down {
  position: absolute;
  width: 100%;
  left: 0;
  top: 64px;
  z-index: 55;
}
.nav_down_wrap {
  padding: 1px 0 0 0;
  border-top: none;
  background-color: rgba(7, 67, 120, 0.6);
}
.nav_down p {
  line-height: 64px;
  text-align: center;
  font-size: 18px;
}
.nav_down p a {
  display: block;
  color: #fff;
}
.nav_down p a:hover {
  background-color: #074378;
}
.header_hd {
  height: 34px;
  line-height: 34px;
  /* background-image: url("../assets/img/st_03.jpg"); */
  background-repeat: repeat-x;
  background-size: auto 100%;
  padding: 0 25px;
  font-size: 12px;
}
.header_top {
  padding: 10px;
}
.mobile {
  display: block;
  height: 20px;
  line-height: 20px;
  padding: 0 8px;
  border: 1px solid #dedede;
  margin-top: 6px;
  font-size: 12px;
  font-weight: 600;
}

.mobile:hover {
  color: #d60f0f;
}
.user_input {
  display: inline-block;
  width: 120px;
}
.user_l {
  display: inline-block;
  margin-left: 10px;
}
.user_sure {
  margin: 0 4px 0 6px;
  height: 26px;
  line-height: 26px;
  padding: 0 10px;
  border: 1px solid #b6b6b6;
  cursor: pointer;
  vertical-align: top;
  margin-top: 3px;
  background-color: #e9e9e9;
  border-radius: 2px;
}
.user_sure:hover {
  background-color: #dddddd;
}
.user_forget:hover {
  color: #d60f0f;
  text-decoration: underline;
}
.mail_dsz {
  display: inline-block;
  height: 20px;
  line-height: 20px;
  padding: 0 8px;
  border: 1px solid #dedede;
  margin-top: 6px;
  font-size: 12px;
  color: #d60f0f;
  margin-left: 30px;
}
.mail_dsz:hover {
  border-color: #d60f0f;
}
.user_wrap {
  display: inline-block;
}
.footerBotttom {
  text-align: center;
}
.topLogoMainRight {
  position: absolute;
  width: 380px;
  height: 50px;
  overflow: hidden;
  bottom: 10px;
  right: 0;
}
.topLogoMainRight .el-input__inner {
  background-color: rgba(255,255,255,0.5);
}
.topLogoMainRight .el-button {
  border: none;
}
.topLogoMainRight {
  float: right !important;
}
.header_search {
  width: 380px;
  height: 51px;
  overflow: hidden;
  float: right;
  position: relative;
}
.header_search input {
  width: 300px;
  height: 38px;
  overflow: hidden;
  outline: none;
  box-shadow: none;
  line-height: 38px;
  font-size: 14px;
  color: #000;
  border-radius: 0px;
  border: none;
}
</style>